import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=f08ff4d8&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08ff4d8",
  null
  
)

export default component.exports